<template>
    <modal :open="open" @close="$emit('close')" title="Page Privacy Options">

        <div v-if="page.home_page">

            <p v-t="'You can not change your home page privacy options, otherwise people won\'t be able to find your other pages. You can set a privacy option for your whole portfolio under \'Settings\' -> \'Privacy\'.'">
            </p>
        </div>

        <div v-if="!page.home_page">

            <form v-on:submit.prevent="savePage()">
                <div>
                    <input type="radio" name="privacy" v-model="page.privacy" value="public">
                    <span v-t="'Public Portfolio'"></span>
                </div>
                <div class="span" v-if="page.privacy=='public'">
                    <p v-t="'Anybody visiting this page will be able to see your it.'"></p>
                </div>
                <div>
                    <input type="radio" :disabled="portfolio.account_type!='pro'" name="privacy" v-model="page.privacy" value="link"> <span class="pro" v-if="portfolio.account_type!='pro'">[PRO]</span> <span v-t="'Secure Link Access Only'"></span>
                </div>
                <div class="span" v-if="page.privacy=='link'">
                    <p v-t="'Only users that visit this page via the below url with a secure token will be able to view this page.'"></p>
                    <field :errors="errors" label="Secure Link" name="password" help="Do not share this link on social media.">
                        <input v-model="page.secure_url" disabled type="text">
                    </field>
                </div>
                <div>
                    <input type="radio" :disabled="portfolio.account_type!='pro'" name="privacy" v-model="page.privacy" value="password"> <span class="pro"  v-if="portfolio.account_type!='pro'">[PRO]</span> <span v-t="'Password Protected'"></span>
                </div>
                <div class="span" v-if="page.privacy=='password'">
                    <p v-t="'Only users with a password you have set below will be able to view this page. This password will need to be shared so do not use your account password.'"></p>
                    <field :errors="errors" label="Password Protected Portfolio" name="password" help="Do not use your account password.">
                        <input v-model="page.password" type="text">
                    </field>
                </div>

                <br>
                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input  :disabled="portfolio.account_type!='pro'" v-model="page.noindex" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    
                    <div class="label"><span class="pro" v-if="portfolio.account_type!='pro'">[PRO]&nbsp;</span> <span v-t="'Hide Portfolio from Search Engines?'"></span></div>
                </field>



                <div class="modal__done">
                    <button :disabled="saving"><span v-if="!saving" v-t="'Save Page'"></span><span v-if="saving"><i class="material-icons">sync</i> Saving</span></button>
                </div>
            </form>
        </div>
    </modal>

</template>

<script>
    import Modal from '@/components/Modal.vue'
    import Field from '@/components/Field.vue'

    export default {
        props: ['open', 'page'],
        components: {
            Modal,
            Field
        },
        data () {
            return {
                errors: {},
                saving: false
            }
        },
        computed: {
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            }
        },
        methods: {
            savePage () {
                this.saving = true;
                this.errors = {}
                this.$http.put('/pages/'+this.page.id+'/privacy/', this.page).then(data =>{
                    this.saving = false
                    this.$store.dispatch('messages/success', 'Privacy settings updated')
                    this.$emit('close')
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            }
        }
    }
</script>
